import { render, staticRenderFns } from "./BLogin.vue?vue&type=template&id=14bd4d7c&scoped=true"
import script from "./BLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./BLogin.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BLogin.vue?vue&type=style&index=0&id=14bd4d7c&prod&lang=scss&scoped=true"
import style1 from "./BLogin.vue?vue&type=style&index=1&id=14bd4d7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bd4d7c",
  null
  
)

export default component.exports